import { useRuntimeTheme } from "hooks/use-runtime-theme";
import type { GlideFC } from "lib/glide-fc";
import { GlideIcon } from "sharedUI/ui/views/glide-icon/glide-icon";
import type { FormElementProps } from "../form-element/form-element";
import FormElement from "../form-element/form-element";
import { BasePickerStyle } from "./base-picker-style";
export interface BasePickerProps extends FormElementProps {
    className?: string;
    isPlaceholder?: boolean;
    onClick?(ev: React.MouseEvent<HTMLElement>): void;
    leftItem?: React.ReactElement;
    rightItem?: React.ReactElement | "clear";
    rightItemOnClick?(ev: React.MouseEvent<HTMLElement>): void;

    progressPercentage?: number;
}

export const BasePicker: GlideFC<React.PropsWithChildren<BasePickerProps>> = props => {
    const { isPlaceholder = false, leftItem, rightItemOnClick, children, onClick, progressPercentage } = props;
    const theme = useRuntimeTheme();

    let { rightItem } = props;
    if (rightItem === "clear") {
        rightItem = <GlideIcon kind="monotone" icon="mt-circular-cross" iconSize={20} fgColor={theme.n600} />;
    }

    return (
        <FormElement {...props}>
            <BasePickerStyle
                data-test="app-picker-button"
                isPlaceholder={isPlaceholder}
                onClick={onClick}
                progressPercentage={progressPercentage}>
                {leftItem && <div className="leftItem">{leftItem}</div>}
                <div className="main-content">{children}</div>
                {rightItem && (
                    <div onClick={rightItemOnClick} className="rightItem">
                        {rightItem}
                    </div>
                )}
                {progressPercentage !== undefined && <div className="progress-bar" />}
            </BasePickerStyle>
        </FormElement>
    );
};
